import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/Home'
import CommunityDetail from '@/pages/community/Detail'
import Privacy from '@/pages/account/Privacy'
import Download from '@/pages/settings/Download'

Vue.use(Router)

const routes = [
  {
    meta: {
      title: '主页'
    },
    name: 'Home',
    path: '/',
    component: Home
  },
  {
    meta: {
      title: '帖子详情'
    },
    name: 'CommunityDetail',
    path: '/community/detail/:id',
    component: CommunityDetail
  },
  {
    meta: {
      title: '隐私条款'
    },
    name: 'Privacy',
    path: '/privacy',
    component: Privacy
  },
  {
    meta: {
      title: 'APP下载'
    },
    name: 'Download',
    path: '/download',
    component: Download
  },
]

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else {
    return { x: 0, y: 0 }
  }
}
// mode: 'history',
// mode: 'hash',
const router = new Router({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    window.document.title = to.meta.title;
  }
  next();
})

// router.afterEach((to, from) => {

// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js